var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Box } from "./..";
import { useBreakpoint } from "../../hooks";
import { DropdownBackdrop } from './';
var buildLss = function (_a) {
    var lss = _a.lss, fullWidthLss = _a.fullWidthLss, smallScreenLss = _a.smallScreenLss, largeScreenLss = _a.largeScreenLss, _b = _a.position, position = _b === void 0 ? 'right' : _b, _c = _a.isFullWidthContentPanel, isFullWidthContentPanel = _c === void 0 ? false : _c, _d = _a.isOpen, isOpen = _d === void 0 ? false : _d, _e = _a.isInlineDropdown, isInlineDropdown = _e === void 0 ? false : _e, _f = _a.isTablet, isTablet = _f === void 0 ? true : _f;
    var getScreenBaseLss = function () {
        if (isInlineDropdown || isTablet)
            return tabletOrSmallerBaseLss;
        return desktopBaseLss;
    };
    var tabletOrSmallerBaseLss = __assign(__assign(__assign({}, (!isInlineDropdown && { position: 'fixed', top: 'auto' })), { width: '100%', maxWidth: '100%', borderRadius: 'none' }), smallScreenLss);
    var desktopBaseLss = __assign({ position: 'absolute', top: 50, width: 'auto', maxWidth: '480px', borderRadius: 4 }, largeScreenLss);
    var baseLss = __assign(__assign(__assign(__assign({}, getScreenBaseLss()), { minWidth: '240px', height: 'auto', p: 'xl', boxShadow: 'sm', overflowX: 'hidden', overflowY: 'auto', display: isOpen ? 'inline-block' : 'none', whiteSpace: 'normal', bg: 'white', right: position === 'left' ? 0 : 'auto', left: position === 'right' ? 0 : 'auto' }), (!isInlineDropdown && { zIndex: 'tooltip' })), lss);
    var fullWidthBaseLss = __assign({ position: 'fixed', top: 'auto', p: 'xl', width: '100%', maxWidth: '100%', height: '100%', border: 'none', borderRadius: 'none', boxShadow: 'none' }, fullWidthLss);
    if (isInlineDropdown)
        return baseLss;
    return isFullWidthContentPanel
        ? __assign(__assign({}, baseLss), fullWidthBaseLss) : baseLss;
};
export var DropdownContent = function (_a) {
    var Content = _a.render, disableBackdrop = _a.disableBackdrop, _b = _a.isResponsive, isResponsive = _b === void 0 ? true : _b, position = _a.position, lss = _a.lss, smallScreenLss = _a.smallScreenLss, largeScreenLss = _a.largeScreenLss, fullWidthLss = _a.fullWidthLss, isFullWidthContentPanel = _a.isFullWidthContentPanel, isOpen = _a.isOpen, isInlineDropdown = _a.isInlineDropdown;
    var isLargeScreen = useBreakpoint('tablet');
    return (React.createElement(Box, { lss: buildLss({
            position: position,
            lss: lss,
            smallScreenLss: smallScreenLss,
            largeScreenLss: largeScreenLss,
            fullWidthLss: fullWidthLss,
            isFullWidthContentPanel: isFullWidthContentPanel,
            isTablet: isResponsive && !isLargeScreen,
            isOpen: isOpen,
            isInlineDropdown: isInlineDropdown
        }) },
        typeof Content !== 'function' ? Content : React.createElement(Content, null),
        !disableBackdrop && isOpen && React.createElement(DropdownBackdrop, null)));
};
//# sourceMappingURL=DropdownContent.js.map